import AWSAuth from './AWSAuth';
import AzureAuth from './AzureAuth';

const AuthV2 = (): JSX.Element => {
  if (import.meta.env.VITE_CLOUD_PROVIDER === 'azure') {
    return <AzureAuth />;
  }
  return <AWSAuth />;
};

export default AuthV2;
